import Alert from "@mui/material/Alert";
import type { QualidadeDadosDreView } from "../types/dre-gerencial.types";

type Props = {
  qualidade: QualidadeDadosDreView | null | undefined;
};

export default function DREQualidadeAlert({ qualidade }: Props) {
  if (!qualidade) return null;

  const semCmv = qualidade.pedidosReceitaSemCmvSnapshot;
  if (semCmv <= 0) return null;

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      {semCmv} pedido(s) com receita no período ainda sem snapshot de CMV — o lucro
      bruto pode estar superestimado. Verifique produtos sem preço de custo ou
      pedidos antigos sem snapshot.
    </Alert>
  );
}
